module.exports = __webpack_public_path__ + "static/growth-compass-ba984838743c11de28e38db3c3766f7f.svg";